import { v4 as uuidv4 } from 'uuid';

export const filesToFileData = (files = [], parent = '', location = '', defaultStatus = 'pending') => {
  const filesArray = Array.from(files);
  const importedFilesData = filesArray.map((file) => ({
    parent,
    fileName: file.name,
    id: uuidv4(),
    status: defaultStatus,
    fileData: file,
    location,
  }));
  const importedFiles = importedFilesData.map((file) => ({
    parent: file.parent,
    fileName: file.fileName,
    id: file.id,
    status: file.status,
    location: file.location,
  }));

  return { importedFiles, importedFilesData };
};

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(''); // Resolve with an empty string if no file is provided
    }

    const reader = new FileReader();

    reader.onload = function (event) {
      const base64String = event.target.result;
      resolve(base64String); // Resolve the promise with the base64 string
    };

    reader.onerror = function (error) {
      reject(error); // Reject the promise if an error occurs
    };

    reader.readAsDataURL(file); // Read the file as Data URL
  });
};
